import { Routes } from '@angular/router';



export enum TRAINEE_ROUTER_TOKENS {
  INVITE = 'invite',
  MANAGE = 'manage',
}

export const TRAINEE_ROUTES: Routes = [
  {
    title: 'Invite Trainee',
    path: TRAINEE_ROUTER_TOKENS.INVITE,
    loadComponent: () => import('./invite-trainee/invite-trainee.component').then(m => m.InviteTraineeComponent),
  },
  {
    title: 'Manage Trainees',
    path: TRAINEE_ROUTER_TOKENS.MANAGE,
    loadComponent: () => import('./manage-trainees/manage-trainees.component').then(m => m.ManageTraineesComponent),
  },
];
